import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MuseumCollection } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class MuseumCollectionsService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true });

  getCollections() {
    return this.http.get<MuseumCollection[]>(`${this.BASE_URL}api/museum/collections`);
  }

  getCollectionById(id: number) {
    return this.http.get<MuseumCollection>(`${this.BASE_URL}api/museum/collections/${id}`);
  }
}
